module.exports = __webpack_public_path__ + "static/media/kurosaki.7fb314d9.webp";